import {Tag} from '@guestapp/ui';

export const AiraloTag = ({children}: {children: string}) => (
  <Tag className="px-2 leading-6 rounded bg-[rgba(119,126,145,0.10)] text-sm font-medium">
    {children}
  </Tag>
);
